import { Component, OnInit } from '@angular/core';
import { MatomoService } from '../../services/matomo/matomo.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.scss'
})
export class PrivacyComponent implements OnInit {
  constructor(private readonly matomo: MatomoService) {}

  ngOnInit(): void {
    this.matomo.trackPageView('/datenschutz', 'Datenschutz');
  }
}
